import axios from 'axios'
import { API_URL } from '../../../../setup/config/env'

export function getCms() {
    return dispatch => {
    return axios.get(API_URL+"/api/cms")
}
}

export function getCategories() {
  return dispatch => {
      return axios.get(API_URL+"/api/cms/category")
  }
}

export function getCmsById({cmsId}) {
    return dispatch => {
    return axios.post(API_URL+"/api/cms",{_id: cmsId})
}
}

export function getPreferredTopics() {
  return dispatch => {
    return axios.get(API_URL + "/api/seo/settings")
  }
}

export function getBaseUrls() {
  return dispatch => {
    return axios.get(API_URL + "/api/seo/websites/base-urls")
  }
}
